<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative h-100 w-100"
  >
    <video class="video-bg" id="video-element1" autoplay muted loop>
      <source
        src="~@/assets/images/pages/login/BG_Login.mp4"
        type="video/mp4"
      />
    </video>
    <div class="content-login">
      <div class="container">
        <div class="row">
          <div class="col">
            <div
              class="position-relative w-100 h-100 text-center mt-3 pt-3 mb-1"
            >
              <img :src="emailImg" alt="emailImg" width="130" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="font-large-1 text-bold text-black text-center m-1">
              Password Reset
            </div>
          </div>
          <div class="col-12 mb-1">
            <div class="font-medium-5 text-black text-center">
              We’ve sent you an email. Just follow the instructions to reset
              your password.
            </div>
            <div class="font-medium-5 text-black text-center">
              CHOCO BCRM Platform account For
              <span class="text-bold text-link">{{ formDataObj.email }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="m-auto">
              <b-form id="forget-password" @submit.prevent="$emit('onGoTo')">
                <div class="m-3 text-center">
                  <div class="w-80 m-auto">
                    <button type="submit" class="btn btn-link">
                      <div class="btn-group d-flex text-black underline">
                        <div class="font-medium-5 text-bold text-black mr-1">
                          Login
                        </div>
                        <div>
                          <feather-icon
                            class="text-black"
                            icon="ArrowRightIcon"
                            size="18"
                          />
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright mt-1 mb-1">
      <img :src="logoChoco" width="150" class="logo-choco" />
    </div>
  </div>
</template>

<script>
import VuexyLogo from "@core/layouts/components/Logo.vue";
import EmailSvg from "@/@core/components/svg/common/EmailOpen.vue";
import logoChoco from "@/assets/images/logo/logo-choco.png";
import forgetPasswordImg from "@/assets/images/pages/forgor-password/Forgot-Mail-BP.png";
import emailImg from "@/assets/images/pages/forgor-password/Forgot-mail1-BP.png";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
} from "@vue/composition-api";

export default {
  directives: {
    Ripple,
  },
  props: { formData: null },
  components: {
    VuexyLogo,
    EmailSvg,
    vSelect,
  },

  setup(props, { emit }) {
    const formDataObj = reactive({
      email: "mim@mail.com",
    });

    onBeforeMount(() => {
      if (props.formData) formDataObj.email = props.formData.email;
    });

    return {
      formDataObj,
      logoChoco,
      emailImg,
      forgetPasswordImg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.content-login {
  width: 700px;
  height: auto;
  display: flex;
  // overflow: hidden;
  z-index: 1;
}

.text-link {
  color: #0d58ff !important;
}

.underline {
  border-bottom: 2px solid transparent;
}

.btn-link .btn-group.underline:hover {
  // transform: translateX(10px);
  border-bottom: 2px solid black;
}
</style>
